module.exports = __webpack_public_path__ + "static/media/coffee.23423edb.svg";